/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

export const ColoredH3 = ({ children, color }) => (
    <h3
        css={css`
            &&& {
                color: ${color};
                font-size: 18px;
                font-weight: 800;
            }
        `}
    >
        {children}
    </h3>
);

export const ColoredH2 = ({ children, color, additionalStyles }) => (
    <h2
        css={[
            additionalStyles,
            css`
                &&& {
                    color: ${color};
                }
            `,
        ]}
    >
        {children}
    </h2>
);

const ColoredH1 = ({ children, color, additionalStyles }) => (
    <h1
        css={[
            additionalStyles,
            css`
                &&& {
                    color: ${color};
                    font-size: 34px;
                    font-weight: 800;
                }
            `,
        ]}
    >
        {children}
    </h1>
);

export default ColoredH1;
